<template>
  <div class="one_boss" :style="style ? style : ''">
    <div :class="['hello', docOne1 ? 'docOne' : 'sou']" :style="style">
      <img src="../assets/official/newlogo.png" alt="" class="helloLest" />

      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
      >
        <el-menu-item index="1">首页</el-menu-item>
        <el-menu-item index="2">新闻动态</el-menu-item>
        <el-menu-item index="3">关于我们</el-menu-item>
      </el-menu>

      <div class="hellobottom">
        <!-- <img
          src="../assets/official/huidong.86791494.gif"
          alt=""
          style="width: 40px; height: 40px"
        /> -->
        <!-- <img
          src="../assets/HelloWorld/huidong.gif"
          alt=""
          style="width: 40px; height: 40px"
        /> -->
        <div
          style="
            font-size: 20px;
            color: #000000;
            line-height: 40px;
            margin: 0 0px 0 2px;
          "
        ></div>

        <el-link
          style="display: flex; justify-content: center; align-items: center"
          target="_blank"
        >
          <el-button
            @click="consoleSwitch()"
            style="
              border: 0;
              color: #545252;
              margin-left: 24px;
              border-radius: 4px;
              border: 1px solid #c0c0c0;
              box-sizing: border-box;
            "
            class="bottoms"
          >
            机构登录
          </el-button>
          <el-button
            @click="inquiry()"
            style="
              background: #0274f7;
              border: 0;
              color: #ffffff;
              margin-left: 24px;
              border-radius: 4px;
            "
          >
            免费试用
          </el-button>
        </el-link>
        <!-- <div style="" class="bottoms">机构登录</div> -->
      </div>
    </div>
    <div
      v-if="bademon"
      style="
        position: fixed;
        top: 0;
        z-index: 999;
        height: 100vh;
        width: 100vw;
        background-color: rgba(204, 204, 204, 0.7);
      "
    ></div>
    <div
      v-if="bademon"
      style="
        width: 346px;
        height: 320px;
        background-color: #fff;
        position: fixed;
        top: 30%;
        z-index: 1000;

        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border-radius: 10px;

        /* padding: 38px;
        box-sizing: border-box; */
      "
    >
      <i
        class="el-icon-close"
        style="position: absolute; top: 10px; right: 10px"
        @click="unInquiry()"
      ></i>
      <div
        style="font-size: 20px; color: rgba(51, 51, 51, 1); font-weight: 500"
      >
        免费定制专属网校
      </div>
      <el-select
        v-model="value"
        placeholder="请选择您所在的行业"
        style="height: 40px; width: 270px; margin: 24px 0 16px 0"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input
        v-model="input"
        placeholder="请输入您的联系方式"
        style="height: 40px; width: 270px"
      ></el-input>
      <div
        style="
          height: 40px;
          width: 270px;
          font-size: 14px;
          color: #0274f7;
          margin: 10px 0 20px 0;
        "
      >
        提交即可获取30天免费试用
      </div>
      <el-button
        @click="submitPhone"
        type="primary"
        style="
          height: 40px;
          width: 270px;
          background-color: #0274f7;
          color: #fff;
        "
        >提交</el-button
      >
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { report } from '@/js/utils'
import axios from 'axios'
import { Loading } from 'element-ui'
export default {
  name: 'HelloWorld',
  data() {
    return {
      bademon: false,
      options: [
        {
          value: '知识付费',
          label: '知识付费',
        },
        {
          value: '兴趣培训',
          label: '兴趣培训',
        },
        {
          value: '大健康',
          label: '大健康',
        },
        {
          value: 'K12教育',
          label: 'K12教育',
        },
        {
          value: '企业培训',
          label: '企业培训',
        },
        {
          value: '医疗美容',
          label: '医疗美容',
        },
      ],
      value: '',
      input: '',
      http: this.$getCookie('http'),
      https: this.$getCookie('https'),
      imgThe_0: 0, //滑入选
      dese: 1, //滑入选
      activeName: '1', // 首页判断在第几个
      activeName1: '1',
      showYou: false, // 判断是否在头部
      showYou1: false, // 判断是否在头部
      docOne1: false, //头部的隐藏与显示
      theTwo: 0,
      eeee: true,
      dddd: false,
      ssss: false,
      aaaa: false, //控制能显示
      style: {
        backgroundColor: '',
      },
      activeIndex: '1',
      paths: ['/', '/new', '/projectA', '/service', 'ailab', '/about'], // 测试数据
      fff: [460, 1346, 2241, 2971], // 测试数据
      ttt: [460, 1260, 2057], // 测试数据
    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.path == '/') {
          this.activeIndex = `1`
          document.documentElement.scrollTop = 0
        }
      },
      // 深度观察监听
      deep: true,
    },
    $router(to, from) {},
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
    this.activeIndex = sessionStorage.getItem('pathKey') || '1'
    const path = this.$route.path
    const userAgent = navigator.userAgent
    if (/mobile/i.test(userAgent) || /android/i.test(userAgent)) {
      this.screenWidth = false
    } else {
      console.log('pc')
    }
    // const screen = document.body.clientWidth
    // if(screen<550){
    //   this.screenWidth=false
    // }
    if (path == '/schemeA' || path == '/schemeB' || path == '/schemeC') {
      this.$router.push('/')
      sessionStorage.setItem('pathKey', 1)
    }
    // const parts = path.split('/');
    // const about = parts[parts.length - 1];
    // const screen = document.body.clientWidth
    // if(about == 'about' && screen < 550){
    //   this.$router.push(this.paths[0])
    // }
  },
  destroyed() {
    window.removeEventListener('popstate', this.goBack, false)
  },
  mounted() {
    if (window.history && window.history.pushState) {
      window.addEventListener('popstate', this.goBack, false)
    }
    this.activeIndex = sessionStorage.getItem('pathKey') || '1'
    window.addEventListener('scroll', this.handleScroll)
    if (this.$route.path == '/new') {
      this.showYou = true
      this.showYou1 = false
    }
    if (this.$route.path == '/open') {
      this.showYou1 = true
      this.showYou = false
    }
  },
  methods: {
    //提交留资信息
    submitPhone() {
      const ccc =
        /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
      if (this.input && this.value && ccc.test(this.input)) {
        axios
          .get(
            'https://manager-api.mischool.com.cn' +
              '/official/mail?' +
              'mobile=' +
              this.input +
              '&industry=' +
              this.value
          )
          .then((res) => {
            if (res.data.code === 200) {
              console.log('发送成功')
              this.bademon = false
              this.$message.success('提交成功')
              this.input = ''
              this.value = ''
            }
          })
      } else {
        this.$message.error('请选择行业或输入手机号')
      }
    },
    // 打开留资弹窗
    inquiry() {
      this.bademon = true
    },
    consoleSwitch() {
      window.open('https://console.mischool.com.cn/')
    },
    // 关闭留资弹窗
    unInquiry() {
      this.bademon = false
    },
    handleClick2(i) {
      // this.$setItem('luyou', this.$route.path)
      // let f = `导航栏->${i == 1 ? '登录' : '免费试用'}`
      // report(true, f)
      // this.$removeItem('shijian')
    },
    goBack() {
      this.activeIndex = sessionStorage.getItem('pathKey')
    },
    huaruThe(i) {
      this.imgThe_0 = i
    },
    // 移入
    aaa(i) {
      if (i === 1) {
        this.ssss = true
        let iconone = document.querySelector('.iconone')
        iconone.classList.add('ijiantou')
      }

      if (i === 2) {
        let icontwo = document.querySelector('.icontwo')
        icontwo.classList.add('ijiantou')
        this.aaaa = true
        if (sessionStorage.getItem('pathKey') != 3) {
          this.imgThe_0 = 0
        } else {
          if (this.$route.path == '/projectD') {
            this.imgThe_0 = 1
          }
          if (this.$route.path == '/projectE') {
            this.imgThe_0 = 2
          }
          if (this.$route.path == '/projectB') {
            this.imgThe_0 = 3
          }
          if (this.$route.path == '/projectC') {
            this.imgThe_0 = 4
          }
          if (this.$route.path == '/light') {
            this.imgThe_0 = 5
          }
        }
      }
      if (i === 3) {
        this.dddd = true
        let icontwo2 = document.querySelector('.icontwo2')
        icontwo2.classList.add('ijiantou')
        if (sessionStorage.getItem('pathKey') != 6) {
          this.dese = 1
        } else {
          if (this.$route.path == '/about') {
            this.dese = 1
          }
          if (this.$route.path == '/about2') {
            this.dese = 2
          }
        }
      }
    },
    // 移出
    bbb(i) {
      if (i === 1) {
        this.ssss = false
        let iconone = document.querySelector('.iconone')
        iconone.classList.remove('ijiantou')
      }
      if (i === 2) {
        let icontwo = document.querySelector('.icontwo')
        icontwo.classList.remove('ijiantou')
        this.aaaa = false
      }
      if (i === 3) {
        let icontwo2 = document.querySelector('.icontwo2')
        icontwo2.classList.remove('ijiantou')
        this.dddd = false
      }
    },
    handleClick(tab, event) {
      document.documentElement.scrollTop = 0 //切换页面到顶部
      if (this.$route.path == '/new') {
        this.$nextTick(() => {
          window.scrollTo({
            top: this.fff[tab.name - 1],
            behavior: 'smooth',
          })
          this.$forceUpdate() // 延迟更新
        })
      }
      if (this.$route.path == '/open') {
        this.$nextTick(() => {
          window.scrollTo({
            top: this.ttt[tab.name - 1],
            behavior: 'smooth',
          })
          this.$forceUpdate() // 延迟更新
        })
      }
    },
    okokok(i) {
      document.documentElement.scrollTop = 0 //切换页面到顶部
      let icontwo = document.querySelector('.icontwo')
      icontwo.classList.remove('ijiantou')
      sessionStorage.setItem('pathKey', 3)
      this.aaaa = false
      if (i == 0) {
        this.paths[2] = '/projectA' //汽车
        this.$router.push(this.paths[2])
      }
      if (i == 1) {
        this.paths[2] = '/projectD' //新能源
        this.$router.push(this.paths[2])
      }
      if (i == 2) {
        this.paths[2] = '/projectE' //家电
        this.$router.push(this.paths[2])
      }
      if (i == 3) {
        this.paths[2] = '/projectB' //零售
        this.$router.push(this.paths[2])
      }
      if (i == 4) {
        this.paths[2] = '/projectC' //金融
        this.$router.push(this.paths[2])
      }
      if (i == 5) {
        this.paths[2] = '/light' // 教育
        this.$router.push(this.paths[2])
      }
      this.activeIndex = '3'
    },
    hhe(i) {
      document.documentElement.scrollTop = 0 //切换页面到顶部
      this.activeIndex = `6`
      sessionStorage.setItem('pathKey', 6)
      if (i == 1) {
        this.paths[5] = '/about'
        this.$router.push('/about')
      }
      if (i == 2) {
        this.paths[5] = '/about2'
        this.$router.push('/about2')
      }
    },
    dedddse(i) {
      this.dese = i
    },
    // 点击切换页面
    handleSelect(key, keyPath) {
      document.documentElement.scrollTop = 0 //切换页面到顶部
      if (sessionStorage.getItem('pathKey') != 3) {
        this.paths[2] = '/projectA'
        this.$router.push(this.paths[2])
      }
      if (sessionStorage.getItem('pathKey') != 6) {
        this.paths[5] = '/about'
        this.$router.push(this.paths[2])
      }
      this.$router.push(this.paths[key - 1])
      this.activeIndex = `${key}`
      if (
        sessionStorage.getItem('pathKey') != key - 1 &&
        sessionStorage.getItem('pathKey')
      ) {
        document.documentElement.scrollTop = 0 //切换页面到顶部
      }
      sessionStorage.setItem('pathKey', key)

      if (key == 2) {
        if (this.$route.path == '/new') {
          this.showYou = true
          this.showYou1 = false
        }
        // 点击就变成/new
        // this.paths[1] = "/new"
        // this.showYou = true
        // this.showYou1 = false
      }
    },
    // 第一个下拉
    handleName(i, y) {
      let iconone = document.querySelector('.iconone')
      iconone.classList.remove('ijiantou')
      this.activeIndex = `${i}`
      if (i == 2) {
        this.paths[1] = '/open'
        this.$router.push(this.paths[1])
        sessionStorage.setItem('pathKey', 2)
        this.ssss = false
        this.$nextTick(() => {
          window.scrollTo({
            left: 100,
            top: this.ttt[y - 5],
            behavior: 'smooth',
          })
          this.activeIndex = '2'
        })
      } else {
        this.paths[1] = '/new'
        this.$router.push(this.paths[1])
        sessionStorage.setItem('pathKey', 2)
        this.ssss = false
        this.$nextTick(() => {
          window.scrollTo({
            left: 100,
            top: this.fff[y - 1],
            behavior: 'smooth',
          })
          this.activeIndex = '2'
        })
      }
    },
    // // 第二个下拉
    // handleSpan(i) {
    //   if (i == 2) {
    //     this.paths[2] = "/span"
    //   } else {
    //     this.paths[2] = "/light"
    //   }
    // },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (this.$route.path == '/new') {
        this.showYou = true
        this.showYou1 = false
        if (document.documentElement.scrollTop > 459) {
          this.docOne1 = true
          let shuzi = document.documentElement.scrollTop
          if (shuzi > 459 && shuzi <= 1240) {
            this.activeName = '1'
          }
          if (shuzi > 1240 && shuzi <= 2170) {
            this.activeName = '2'
          }
          if (shuzi > 2170 && shuzi <= 2895) {
            this.activeName = '3'
          }
          if (shuzi > 2895) {
            this.activeName = '4'
          }
        } else {
          this.docOne1 = false
        }
      }
      if (this.$route.path == '/open') {
        this.showYou1 = true
        this.showYou = false
        if (document.documentElement.scrollTop > 459) {
          this.docOne1 = true
          let shuzi = document.documentElement.scrollTop
          if (shuzi > 459 && shuzi <= 1259) {
            this.activeName1 = '1'
          }
          if (shuzi > 1259 && shuzi <= 2056) {
            this.activeName1 = '2'
          }
          if (shuzi > 2056) {
            this.activeName1 = '3'
          }
        } else {
          this.docOne1 = false
        }
      }
      // let offsetTop = document.querySelector(".header").offsetTop;
      //设置背景颜色的透明读
      if (scrollTop) {
        this.style.backgroundColor = `rgba(250, 250, 250,1)`
        // this.style.backgroundColor = `rgba(250, 250, 250,${scrollTop /
        //   (scrollTop + 10)})`;
        // this.color = true;
      } else if (scrollTop == 0) {
        // this.style.backgroundColor = "transparent"
        this.style.backgroundColor = '#ffffff'
        // this.color = false;
      }
    },
    jaide() {},
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>

<style scoped lang="scss">
::v-deep
  .el-menu--horizontal
  > .el-menu-item[data-v-469af010]:not(.is-disabled):focus {
  color: #0274f7;
  background: transparent;
}

.one_boss {
  width: 100%;
  display: flex;
  background: #ffffff;
  flex-direction: column;
  align-items: center;
}

.el-link.is-underline:hover:after {
  border-bottom: transparent;
}

.el-button:focus,
.el-button:hover {
  border-color: #dcdfe6;
  background-color: #ffffff;
}

.docOne {
  margin: -82px 0 0;
  transition: all 0.3s;
}

.sou {
  margin: 0;
  transition: all 0.3s;
}

// 将
.ijiantou {
  transition: all 0.5s;
  color: #0274f7;
  transform: rotate(180deg);
}

.boss_a {
  // height: 78px;
}

.boss_b {
  z-index: 99;
  left: -256px;
  background: #ffffff;
  position: absolute;
  top: 60px;
  border-top: 2px solid #0274f7;
  box-sizing: border-box;
}

.boss_c {
  width: 850px;
  /* z-index: 99; */
  // height: 298px;
  background: #ffffff;
  position: absolute;
  top: 60px;
  left: -400px;
  border-top: 2px solid #0274f7;
  box-sizing: border-box;
  box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.15);
  /* display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; */
}

.the_1 {
  /* width: 100%; */
  /* padding: 30px 10px 30px 40px; */
  display: flex;
  position: relative;

  .ok_the {
    position: absolute;
    top: -17px;
    right: 410px;
    /* 圆角的位置需要细心调试哦 */
    width: 0;
    z-index: 99;
    height: 0;
    font-size: 0;
    border: solid 8px;
    /* background: transparent; */
    border-color: transparent transparent #0274f7 transparent;
  }

  .the_2 {
    width: 254px;
    height: 270px;
    border-right: 1px solid #d9d9d9;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    margin: 30px 0;

    .the_3 {
      height: 30px;
      margin-left: 40px;
      padding: 0 16px 0 0;
      /* background: #0274f7; */
      display: flex;
      justify-content: space-between;

      .the_4 {
        display: flex;
        align-items: center;
        color: #3d3d3d;

        div {
          &.activeThe {
            color: #0274f7;
          }
        }

        img {
          width: 16px;
          height: 16px;
          margin-right: 7px;
        }
      }

      .one_the_3 {
        width: 30px;
        height: 30px;
      }
    }
  }

  .theOne_1 {
    width: 596px;

    /* background: #0274f7; */
    // height: 238px;
    // margin-top: 30px;
    .the_99 {
      padding-left: 25px;
      /* height: 238px; */
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .theOne_2 {
        .one_the1 {
          display: flex;
          justify-content: space-between;

          // margin-bottom: 19px;
          .one_1 {
            color: #333333;
            font-size: 22px;
            font-weight: bold;
          }

          .one_2 {
            font-size: 16px;
            margin-right: 24px;
            color: #333333;
          }

          img {
            width: 22px;
            height: 22px;
          }
        }

        .one_the4 {
          //  display: flex;
          //  align-items:center ;
          height: 66px;
          line-height: 22px;
          margin-right: 24px;
          white-space: normal;

          img {
            width: 6px;
            height: 6px;
            margin-right: 4px;
          }

          div {
            line-height: 22px;
            width: 530px;
            font-size: 16px;
            font-weight: 500;
            color: #808080;
          }
        }
      }

      .the_100 {
        margin-top: 43px;

        .boss_12 {
          height: 22px;
          font-size: 16px;
          font-weight: bold;
          color: #333333;
          line-height: 22px;
          margin-bottom: 16px;
        }

        .boss_13 {
          display: flex;

          img {
            margin-right: 24px;
            width: 104px;
            height: 70px;
          }
        }
      }
    }
  }
}

::v-deep .el-menu-item [class^='el-icon-'] {
  margin: 0;
}

.one_a {
  display: flex;
  padding: 32px 40px;
  width: 500px;
  position: relative;

  .one_o {
    position: absolute;
    top: -17px;
    right: 272px;
    width: 0;
    z-index: 99;
    height: 0;
    font-size: 0;
    border: solid 8px;
    /* background: transparent; */
    border-color: transparent transparent #0274f7 transparent;
  }

  .one_b {
    /* width: 282px; */
    border-right: 1px solid #d9d9d9;
  }

  .one_c {
    /* width: 218px; */
    .two_a {
      padding-left: 32px;
    }
  }
}

.one_e {
  display: flex;
  height: 20px;
  align-items: center;

  .one_f {
    width: 2px;
    height: 16px;
    background: #0274f7;
    margin-right: 8px;
  }

  .one_g {
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    line-height: 21px;
  }
}

.one_h {
  padding: 16px 32px 0 10px;

  .one_i {
    .one_j {
      display: flex;
      height: 22px;
      font-size: 16px;
      font-weight: bold;
      color: #000000;
      line-height: 22px;
      margin-bottom: 8px;
    }

    .one_k {
      height: 17px;
      font-size: 12px;
      font-weight: 400;
      color: #818181;
      line-height: 17px;
      margin-bottom: 20px;

      &.active {
        color: #db7d47;
      }
    }
  }
}

// 3下拉
.bbdej {
  width: 127px;
  height: 130px;
  background: #ffffff;
  position: absolute;
  top: 60px;
  color: #000000;
  left: -5px;
  border-top: 2px solid #0274f7;
  box-sizing: border-box;
  box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.15);
}

.bbdej1 {
  padding: 10px 20px;
  line-height: 40px;
  &.active {
    color: #0274f7;
  }
}
.bbdej1:hover {
  color: #0274f7;
}

.ImgTou {
  width: 13px;
  margin-left: 3px;
}

.hello {
  width: 1440px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .helloLest {
    height: 40px;
    // margin-right: 70px;
    padding-left: 120px;
  }

  .hellobottom {
    /* margin-left: 139px; */
    display: flex;
    padding-right: 120px;

    .one_oo {
      color: #646464;
      text-decoration: none;
    }

    .el-button {
      height: 40px;
      width: 100px;
      border-radius: 0;
      font-size: 16px;
      font-weight: 400;
      padding: 0;
      color: #646464;
    }

    .el-button + .el-button {
      margin-left: 20px;
    }
  }
}

// ::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
//   background-color: transparent;
//   color: #0274f7;
// }

// .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
// .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
// .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
//   background: transparent;
//   color: #0274f7;
//   /* color: #333333; */
// }
.el-menu--horizontal > .el-menu-item.is-active {
  height: 100%;
  // line-height: 78px;
  // background: #ffffff !important;
  color: #0274f7 !important;
  // background: #0274f7 !important;
  // color: #ffffff !important;
  border-bottom: 0px solid transparent;
  // color: #0274f7 !important;
}

::v-deep .el-menu--horizontal > .el-menu-item,
.el-menu--horizontal > .el-submenu .el-submenu__title {
  // height: 78px;
  // line-height: 78px;
  padding: 0 16px;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
}

::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title {
  // height: 78px;
  // line-height: 78px;
  padding: 0;
  font-size: 16px;
  font-weight: 400;
  margin: 0 32px 0 0;
  color: #333333;
}

/* ::v-deep .el-submenu__title {
  height: 40px;
  line-height: 40px;
} */
.el-menu.el-menu--horizontal {
  background: transparent;
  border: 0;
  padding-top: -10px;
}

.the_a {
  width: 2000px;
  background: #ffffff;
  z-index: 99;
  margin: 22px 0 0;
  display: flex;
  justify-content: center;
}

.the_a ::v-deep .el-tabs__item {
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  padding: 0 148px;
}

.the_a ::v-deep .el-tabs__nav-scroll {
  height: 50px;
  padding: 0 148px;
  width: 2000px;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #d9d9d9;
}

.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover {
  background: #fafafa;
  // background: #0274f7;
  color: #0274f7;
}

.the_a ::v-deep .el-tabs__content {
  display: none;
}

.the_a ::v-deep .el-tabs__nav {
  height: 50px;
}

.the_a ::v-deep .el-tabs__item.is-active {
  color: #0274f7;
}

.the_a ::v-deep .el-tabs__active-bar {
  background: #0274f7;
}

.the_a ::v-deep .el-tabs__item:hover {
  color: #0274f7;

  /* background: #0274f7; */
}

.the_a ::v-deep .el-tabs__nav-wrap::after {
  background: transparent;
  /* background: #0274f7; */
}
.bottoms {
  display: inline-block;
  box-sizing: border-box;
  height: 40px;
  line-height: 40px;
  text-align: center;
  width: 100px;
  color: #545252;
  margin-left: 24px;
  border-radius: 4px;
  background-color: #fff;
  font-size: 16px;
  border: 1px solid #c0c0c0;
  cursor: pointer;
}
// ::v-deep .bottoms :hover {
//   background-color: red !important;
// }
</style>
